'use client';

import { useTranslations } from 'next-intl';
import { cn } from '@/app/utils';

interface TaskPanelProps {
  className?: string;
}

const LoadingDotsIcon = () => (
  <div
    className="mr-1.5 ml-1 aspect-square rounded-full text-system-white [animation:loader_2s_infinite_linear] [height:0.93px] [transform:translateX(-8.8px)] [width:0.93px]"
    style={{
      boxShadow:
        '4.4px -4.4px 0 0px, 8.8px -4.4px 0 0px, 13.2px -4.4px 0 0px, 4.4px 0 0 1.16px, 8.8px 0 0 1.16px, 13.2px 0 0 1.16px, 4.4px 4.4px 0 0px, 8.8px 4.4px 0 0px, 13.2px 4.4px 0 0px',
    }}
  />
);

/**
 * 任务运行中横条：仅作为"当前 session 有异步任务在跑"的提示。
 * cron/spawn 的具体产出已并入对话流（messages）按时间顺序渲染，这里不再聚合展示内容。
 */
export const TaskPanel = ({ className }: TaskPanelProps) => {
  const t = useTranslations();

  return (
    <div
      className={cn(
        '-mb-3 relative z-10 mx-3 overflow-hidden rounded-tl-12 rounded-tr-12 border-system-white08 border-x border-t bg-system-white04 light:bg-[#F4F4FA] pb-3',
        className,
      )}
    >
      <div className="flex items-center justify-between gap-3 px-4 py-3">
        <div className="flex min-w-0 items-center gap-2">
          <LoadingDotsIcon />
          <span className="truncate text-sm text-system-white">{t('claw.chat.activeTaskBanner')}</span>
        </div>
      </div>
    </div>
  );
};
